import React from "react";
import {defineMessages, FormattedMessage} from "react-intl";
import {TierLevel} from "../../shared/api/loyaltyApi";
import {NumberOrDashWrapper} from "../wrappers/NumberOrDashWrapper";
import {StyledTable, StyledTitle, StyledContainer} from "../styles";

interface LoyaltyCustomerTierLevelsProps {
    levels: TierLevel[];
}

const messages = defineMessages({
    title: {
        id: "loyaltyCustomerHistorical.levelsList.title",
        defaultMessage: "Levels info",
    },
    levels: {
        id: "loyaltyCustomerHistorical.levelsList.levels",
        defaultMessage: "Levels",
    },
    transactionsNumber: {
        id: "loyaltyCustomerHistorical.levelsList.transactionsNumber",
        defaultMessage: "Num. of reservations",
    },
    transactionsAmount: {
        id: "loyaltyCustomerHistorical.levelsList.transactionsAmount",
        defaultMessage: "Sum. of amounts",
    }
});

function LoyaltyCustomerTierLevels(props: LoyaltyCustomerTierLevelsProps): JSX.Element {
    return (
        <StyledContainer>
            <StyledTitle><FormattedMessage {...messages.title} /></StyledTitle>
            <StyledTable bordered>
                <thead>
                    <tr>
                        <th><FormattedMessage {...messages.levels} /></th>
                        <th><FormattedMessage {...messages.transactionsNumber} /></th>
                        <th><FormattedMessage {...messages.transactionsAmount} /></th>
                    </tr>
                </thead>
                <tbody>
                {props.levels.map((it, idx) => (
                    <tr key={idx}>
                        <td>{it.ticker}</td>
                        <td><NumberOrDashWrapper>{it.amount?.transactionsNumber}</NumberOrDashWrapper></td>
                        <td><NumberOrDashWrapper>{it.amount?.spentAmount?.units}</NumberOrDashWrapper></td>
                    </tr>
                ))}
                </tbody>
            </StyledTable>
        </StyledContainer>
    )
}

export default LoyaltyCustomerTierLevels;